/* eslint-disable max-len */

const BASE_URL = 'https://rss.getrael.com/api';

export const apiUrls = {
  common: {
    login: {
      // url: 'http://13.52.35.21:8081/api/user/login',
      url: `${BASE_URL}/user/login`,
      method: 'POST',
      auth: false,
      data: '',
    },
  },
  revenue: {
    getRevenue: {
      url: `${BASE_URL}/{{vendor}}/revenue/`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  product: {
    getProduct: {
      url: `${BASE_URL}/product/`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  marketplace: {
    getMarketplace: {
      url: `${BASE_URL}/marketplace/`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  compareMonths: {
    compareMonths: {
      url: `${BASE_URL}/{{vendor}}/monthlysales/compare/?fromyear={from}&toyear={to}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  compareMonthsAll: {
    compareMonthsAll: {
      url: `${BASE_URL}/{{vendor}}/monthlysales/compare/all?fromyear={from}&toyear={to}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  salesCategoryByDay: {
    getSalesCategoryByDay: {
      url: `${BASE_URL}/{{vendor}}/revenue/daily/sales?fromyear={from}&toyear={to}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  salesBreakdown: {
    getSalesBreakdown: {
      url: `${BASE_URL}/{{vendor}}/revenue/daily/sales/breakdown?fromyear={from}&toyear={to}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  salesByRegion: {
    getSalesByRegion: {
      url: `${BASE_URL}/revenue/amazon/countrysales/all`,
      method: 'POST',
      auth: true,
      data: '',
    },
    getTopSalesLocations: {
      url: `${BASE_URL}/revenue/amazon/sales/region`,
      method: 'POST',
      auth: true,
      data: '',
    },
    getTopSalesCategory: {
      url: `${BASE_URL}/revenue/amazon/sales/prodcategory`,
      method: 'POST',
      auth: true,
      data: '',
    },
    // getTopSalesCategory: {
    //   url: `http://13.52.35.21:8081/api/revenue/amazon/topsales/prodcategory`,
    //   method: 'POST',
    //   auth: true,
    //   data: '',
    // },
  },
  AOV: {
    getAOV: {
      url: `${BASE_URL}/{{vendor}}/revenue/averageordervalue/daily?fromyear={from}&toyear={to}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  categorySales: {
    categorySales: {
      url: `${BASE_URL}/{{vendor}}/revenue/monthly/sales?fromyear={from}&toyear={to}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  customer: {
    customer: {
      url: `${BASE_URL}/revenue/amazon/shipments/customers`,
      method: 'POST',
      auth: true,
      data: '',
    },
  },
  order: {
    getOrders: {
      url: `${BASE_URL}/revenue/amazon/orders/all`,
      method: 'POST',
      auth: true,
      data: '',
    },
  },
  profit: {
    getProfit: {
      url: `${BASE_URL}/{{vendor}}/revenue/profit/get`,
      method: 'POST',
      auth: true,
      data: '',
    },
  },
  monthlySubscription: {
    getMonthlySubscription: {
      url: `${BASE_URL}/amazon/subcription/monthly/orders/get?fromyear={{fromyear}}&toyear={{toyear}}`,
      // url: `${BASE_URL}/amazon/subcription/monthly/orders/get?fromyear={{fromyear}}&toyear={{toyear}}&frommonth={{frommonth}}&tomonth={{tomonth}}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  revenueFromSubscription: {
    getRevenueFromSubscription: {
      url: `${BASE_URL}/revenue/amazon/subcription/monthly/sales?fromyear={{fromyear}}&toyear={{toyear}}`,
      // url: `${BASE_URL}/revenue/amazon/subcription/monthly/sales?fromyear={{fromyear}}&toyear={{toyear}}&frommonth={{frommonth}}&tomonth={{tomonth}}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  subscribersByCategory: {
    getSubscribersByCategory: {
      url: `${BASE_URL}/amazon/subscriptionsdetail/subscriber`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  inventoryFBAForecast: {
    getInventoryFBAForecast: {
      url: `${BASE_URL}/amazon/fbainventory/forecast?date={{date}}`,
      method: 'POST',
      auth: true,
      data: '',
    },
  },
  advBudgetPerformance: {
    getAdvBudgetPerformance: {
      url: `${BASE_URL}/amazon/advertising/budget/performance?fromDate={{fromDate}}&toDate={{toDate}}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  newReturnCustomer: {
    getNewReturnCustomer: {
      url: `${BASE_URL}/{{vendor}}/reports/customers/newvsrepeat`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  promotionByRevenue: {
    getPromotionByRevenue: {
      url: `${BASE_URL}/amazon/promotion/revenue/daily/get`,
      method: 'POST',
      auth: true,
      data: '',
    },
  },
  monthEndInventory: {
    getMonthEndInventory: {
      url: `${BASE_URL}/amazon/inventory/monthly/get?date={{date}}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  advSales: {
    getAdvSales: {
      url: `${BASE_URL}/amazon/advertising/sales/get?fromDate={{fromdate}}&toDate={{todate}}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  advProducts: {
    getAdvProducts: {
      url: `${BASE_URL}/amazon/advertising/products/get?country={{country}}&fromDate={{fromdate}}&toDate={{todate}}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  advKeywords: {
    getAdvKeywords: {
      url: `${BASE_URL}/amazon/advertising/keywords/get?country={{country}}&fromDate={{fromdate}}&toDate={{todate}}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  advCampaign: {
    getAdvCampaign: {
      url: `${BASE_URL}/amazon/advertising/campaingns/get?fromDate={{fromDate}}&toDate={{toDate}}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  subscribers: {
    getSubscibers: {
      url: `${BASE_URL}/amazon/subscriptions/subscriber`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  pagetrafficwithconversion: {
    getPageTrafficWithConversion: {
      url: `${BASE_URL}/amazon/reports/pagetrafficwithconversion/viewsvssales?fromdate={{fromDate}}&todate={{toDate}}&sku={{sku}}`,
      method: 'GET',
      auth: true,
      data: '',
    },
    getPageTrafficWithConversionForGraph: {
      url: `${BASE_URL}/amazon/reports/pagetrafficwithconversion/revenue/?fromdate={{fromDate}}&todate={{toDate}}&sku={{sku}}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  repurchaserate: {
    getRepurchaserate: {
      url: `${BASE_URL}/{{vendor}}/reports/repurchaserate/get`,
      method: 'POST',
      auth: true,
      data: '',
    },
  },
  basketAnalysis: {
    getBasketAnalysis: {
      url: `${BASE_URL}/{{vendor}}/reports/basketanalysis/get`,
      method: 'POST',
      auth: true,
      data: '',
    },
  },
  dashboard: {
    getDashboardRevenue: {
      url: `${BASE_URL}/{{vendor}}/dashboard/revenue?fromDate={{fromDate}}&toDate={{toDate}}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  bestTimes: {
    getBestTimes: {
      url: `${BASE_URL}/{{vendor}}/revenue/besttime/get`,
      //  url: `${BASE_URL}/revenue/{{vendor}}/besttime/get`,
      method: 'POST',
      auth: true,
      data: '',
    },
  },
  lifeTimeValue: {
    getLifeTimeValue: {
      url: `${BASE_URL}/{{vendor}}/revenue/lifetimevalue/get`,
      method: 'POST',
      auth: true,
      data: '',
    },
  },
  wholesaleCustomer: {
    getWholesaleCustomer: {
      url: `${BASE_URL}/wholesale/customers/get`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  wholesaleOrder: {
    getWholesaleOrder: {
      url: `${BASE_URL}/wholesale/orders/get?fromdate={{fromDate}}&todate={{toDate}}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  revenueFromCustomer: {
    getRevenueFromCustomer: {
      url: `${BASE_URL}/{{vendor}}/revenue/customer/get?fromDate={{fromDate}}&toDate={{toDate}}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  revenueForKorea: {
    getRevenueForKorea: {
      url: `${BASE_URL}/korea/revenue/get`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  revenueByCustomerForKorea: {
    getRevenueByCustomerForKorea: {
      url: `${BASE_URL}/korea/revenue/customer/get?year={{year}}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  posSales: {
    getPosSales: {
      url: `${BASE_URL}/wholesale/pos/sales`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  posSalesByProduct: {
    getPosSalesByProduct: {
      url: `${BASE_URL}/wholesale/pos/sales/byproduct`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  pos: {
    getPos: {
      url: `${BASE_URL}/wholesale/pointofsales/getAll`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  ShopifySessionByReferrer: {
    getShopifySessionByReferrer: {
      url: `${BASE_URL}/shopify/reports/referreral/sessions/get`,
      method: 'POST',
      auth: true,
      data: '',
    },
  },
  ShopifySessionByReferrerAll: {
    getShopifySessionByReferrerAll: {
      url: `${BASE_URL}/shopifySessionsByReferrer/`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  ShopifySalesByReferrer: {
    getShopifySalesByReferrer: {
      url: `${BASE_URL}/shopify/reports/referreral/get`,
      method: 'POST',
      auth: true,
      data: '',
    },
  },
  ShopifySalesByReferrerAll: {
    getShopifySalesByReferrerAll: {
      url: `${BASE_URL}/shopifySalesByReferrer/`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  ShopifySalesByChannel: {
    getShopifySalesByReferrer: {
      url: `${BASE_URL}/shopify/reports/channel/get`,
      method: 'POST',
      auth: true,
      data: '',
    },
  },
  ShopifySalesByChannelAll: {
    getShopifySalesByChannelAll: {
      url: `${BASE_URL}/shopifySalesByChannel/`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  VirtualBundleSales: {
    getVirtualBundleSales: {
      url: `${BASE_URL}/amazon/reports/virtualbundlesales?fromdate={{fromdate}}&todate={{todate}}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  VirtualBundleSalesDetails: {
    getVirtualBundleSalesDetails: {
      url: `${BASE_URL}/amazon/virtualbundle/getAll`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  PromotionsForPrime: {
    getPromotionsForPrime: {
      url: `${BASE_URL}/amazon/promotions/sales/get?fromDate={{fromdate}}&toDate={{todate}}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  CustomerTransition: {
    getCustomerTransition: {
      url: `${BASE_URL}/amazon/reports/customer/transition?fromdate={{fromdate}}&todate={{todate}}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  dataIngestionBatchStatus: {
    getDataIngestionBatchStatus: {
      url: `${BASE_URL}/batchdetails/?fromDate={{fromdate}}&toDate={{todate}}`,
      method: 'POST',
      auth: true,
      data: '',
    },
  },
  SKU: {
    getSKU: {
      url: `${BASE_URL}/position-tracker/`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  searchPositionTracker: {
    getSearchPositionTracker: {
      urlWithSKU: `${BASE_URL}/position-tracker/bydate?sku={{sku}}&fromdate={{fromdate}}&todate={{todate}}`,
      method: 'POST',
      auth: true,
      data: '',
    },
    getSearchPositionTrackerWithoutSKU: {
      urlWithOutSKU: `${BASE_URL}/position-tracker/bydate?sku&fromdate={{fromdate}}&todate={{todate}}`,
      method: 'POST',
      auth: true,
      data: '',
    },
  },
  peformanceBySKU: {
    getPerformanceBySKU: {
      url: `${BASE_URL}/amazon/performance/sku?fromdate={from}&todate={to}&sku={sku}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },

  returnRefundByDay: {
    getReturnRefundByDay: {
      url: `${BASE_URL}/return-refund/{type}/data?fromyear={from}&toyear={to}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },

  returnRefundByMonth: {
    getReturnRefundByMonth: {
      url: `${BASE_URL}/return-refund/monthly/data?fromyear={from}&toyear={to}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
  TaxReport: {
    getTaxReport: {
      url: `${BASE_URL}/amazon/reports/taxreport/get?fromdate={{fromdate}}&todate={{todate}}`,
      method: 'GET',
      auth: true,
      data: '',
    },
  },
};

export default apiUrls;
